import { render, staticRenderFns } from "./onlineDialog.vue?vue&type=template&id=04e63e1e&scoped=true"
import script from "./onlineDialog.vue?vue&type=script&lang=js"
export * from "./onlineDialog.vue?vue&type=script&lang=js"
import style0 from "./onlineDialog.vue?vue&type=style&index=0&id=04e63e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e63e1e",
  null
  
)

export default component.exports